import { render, staticRenderFns } from "./ModalCreateTransaction.vue?vue&type=template&id=2ba994fd"
import script from "./ModalCreateTransaction.vue?vue&type=script&lang=js"
export * from "./ModalCreateTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports